

export interface CorePasswordProfile {
    id: string
    name: string
    tokenSets: string[]
    minLength: number
    wordLists?: CorePasswordProfileWordList[]
}

export interface FormPasswordProfile {
    id?: string
    name: string
    tokenSets: string[]
    minLength: number
    wordLists?: CorePasswordProfileWordList[]
}

export interface CorePasswordProfileWordList {
    passwordProfileId?: string
    wordListId: string
    type: WordListType
}

export enum WordListType {
    Undefined = 0,
    Included = 1,
    Forbidden = 2
}

export interface CoreWordList {
    id: string
    name: string
    blobPath: string
}